import {
	List,
	Datagrid,
	TextField,
	EditButton,
	CreateButton,
	FunctionField,
} from "react-admin"
import { ToggleButton } from "./enigmaToggleButton"

export const EnigmaList = (props) => (
	<List {...props} pagination={false} actions={<CreateButton label="Ajouter" />}>
		<Datagrid>
			<TextField source="id" label="ID" />
			<TextField source="title" label="Titre de l'énigme" />
			<FunctionField
				label="Type"
				render={record => record.type === "website" ? 'article web' : record.type}
			/>
			<FunctionField
				label="État"
				render={(record) => <ToggleButton record={record} />}
			/>
			<EditButton label="Editer" />
		</Datagrid>
	</List>
)
